<!--
Author: TangChen
Date: 2018-12-26
Desc: 定投基金历史扣款详情，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-plan-deduction bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="time-select">
            <span class="demonstration">选择交易时间</span>
            <el-radio-group v-model="tabPosition" class="time-sel-btn" size="mini">
                <el-radio-button v-for="type in tradeTimeArr" :key="type.val" :label="type.val">
                    {{ type.text }}
                </el-radio-button>
            </el-radio-group>
            <div v-if="tabPosition==='5'" class="custom-time">
                <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                <el-button size="small" round v-on:click.prevent="searchFund">
                    查询
                </el-button>
            </div>
        </el-row>
        <el-table :data="showData" style="width: 100%" class="tab-list-tit">
            <el-table-column label="基金名称" align="center">
                <template slot-scope="scope">
                    <span>{{ fund.planpaytype === '1'?scope.row.fundname:scope.row.targetfundname }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="transactiondate" label="申请日期" align="center" :formatter="formatterDate" />
            <el-table-column prop="cfmdate" label="确认日期" align="center" :formatter="formatterPay" />
            <el-table-column prop="cfmamount" label="扣款金额" align="center" :formatter="formatterNum" />
            <el-table-column prop="cfmvol" label="确认份额" align="center" :formatter="formatterNum" />
            <el-table-column prop="nav" label="确认净值" align="center" :formatter="formatterNav" />
            <el-table-column prop="charge" label="手续费" align="center" :formatter="formatterNum" />
            <el-table-column prop="status" label="处理结果" align="center" :formatter="formatterStatus" />
        </el-table>
        <el-row v-if="tableData.length>conf.PAGE_SIZE" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                background
                :current-page.sync="curPage"
                layout="prev, pager, next"
                :total="tableData.length"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>
<script>
import format from "date-fns/format";

import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";
export default {
    name: "PlanDeduction",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            tabPosition: "", // 初始化选中按钮值
            tableData: [],
            conf: {}, // 初始化配置文件内容
            fund: {},
            showData: [],
            curPage: 1,
            endDate: "",
            beginDate: "",
            tradeTimeArr: [// 时间周期
                // {val: '1', text: '近一个月'},
                // {val: '2', text: '近三个月'},
                { val: "3", text: "近半年" },
                { val: "4", text: "近一年" },
                { val: "6", text: "所有" }
                // {val: '5', text: '自定义'}
            ],
            dateSet: { type: "2", min: "1990-01-01", size: "mini" }
        };
    },
    watch: {
        // 监听切换时间选择周期
        tabPosition (val) {
            this.endDate = this.nowDate;
            if (val === "1") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
            } else if (val === "2") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 3);
            } else if (val === "3") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 6);
            } else if (val === "4") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1, true);
            } else if (val === "6") {
                this.beginDate = "19900101";
            } else if (val === "5") {
                return;
            }
            this.curPage = 1;
            this.doAction();
        }
    },
    created () {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.tabPosition = "3";
        this.conf = this.$util.getConfig().const;
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
    },
    methods: {
        // 查询用户定投收益明细
        getIncomeData (cate) {
            const _this = this;
            let data = {
                planno: this.fund.planno,
                begindate: this.beginDate,
                paycenterid: this.fund.paycenterid,
                channelid: this.fund.channelid,
                enddate: this.endDate
            };
            this.$util.request("trade/plan/" + (this.fund.planpaytype === "1" ? "normal" : "xjb") + "/hisdeduct", data).then(res => {
                if (res.data) {
                    _this.tableData = res.data;
                    _this.dataReset(1);
                }
            });
        },
        // 获取用户选中时间区间
        dateInterval (val) {
            if (val.beginDate && val.endDate) {
                // convert "YYYY-MM-DD" to "YYYYMMDD"
                this.beginDate = val.beginDate.replace(/-/g, "");
                this.endDate = val.endDate.replace(/-/g, "");
            }
        },
        // 对基金频繁查询请求做处理
        doAction (cb) {
            const _this = this;
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getIncomeData(cb);
            }, 10);
        },
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterPay (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterStatus (row, column, value) {
            return value === "0000" ? "成功" : "失败";
        },
        formatterNum (row, column, value) {
            return this.$util.fmtNum(value);
        },
        formatterNav (row, column, value) {
            return this.$util.fmtNum(value, 4);
        },
        dataReset (val) {
            const _x = this.conf.PAGE_SIZE;
            if (this.tableData.length > _x) {
                this.showData = this.tableData.slice((val - 1) * _x, (this.tableData.length > val * _x ? val * _x : this.tableData.length));
            } else {
                this.showData = this.tableData;
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-plan-deduction {
    .time-select {
        text-align: center;
    }
    .el-row.time-select {
        margin-bottom: 0;
        border-bottom: 1px solid $border-color5;
    }
    .tab-list-tit.el-table th {
        background-color: $bg1;
    }
    .custom-time {
        display: inline-block;
        vertical-align: middle;
        .comp-date-picker {
            width: auto;
        }
        .el-button {
            min-width: 100px;
            border-color: $color-b;
            color: $color-b;
            background-color: $bg5;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }
}
</style>
